// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 데이터 내보내기 모달 — 프로젝트 컨벤션: 색 전용 transition, fade-in 160ms, reduced-motion 가드 */

.export-modal-overlay {
  position: fixed;
  inset: 0;
  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1200;
}

.export-modal {
  width: 520px;
  max-width: calc(calc(100vw / var(--app-zoom, 1)) - 32px);
  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 64px);
  display: flex;
  flex-direction: column;
  background: #fff;
  color: #374151;
  border-radius: 10px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);
  animation: export-modal-in 160ms ease-out;
}

@keyframes export-modal-in {
  from { opacity: 0; transform: translateY(-3px); }
  to   { opacity: 1; transform: translateY(0); }
}

.export-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #e5e7eb;
}

.export-modal-header h2 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 7px;
}

.export-modal-close {
  border: none;
  background: none;
  color: inherit;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: background-color 150ms ease;
}

.export-modal-close:hover { background: rgba(0, 0, 0, 0.06); }

.export-modal-body {
  padding: 16px 18px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.export-source {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 9px 12px;
  display: flex;
  flex-direction: column;
  gap: 5px;
  font-size: 12px;
}

.export-source-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  min-width: 0;
}

.export-sql {
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1 1;
  min-width: 0;
}

.export-field {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}

.export-label {
  flex-shrink: 0;
  width: 74px;
  font-size: 12px;
  color: #6b7280;
}

.export-field input[type="text"],
.export-field select {
  flex: 1 1;
  min-width: 0;
  padding: 6px 9px;
  font-size: 13px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #fff;
  color: inherit;
  transition: border-color 150ms ease;
}

.export-field input[type="text"]:focus,
.export-field select:focus { outline: none; border-color: #3b82f6; }

.export-filename {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.export-ext {
  flex-shrink: 0;
  font-size: 12px;
  color: #9ca3af;
  font-family: 'Consolas', 'Monaco', monospace;
}

.export-checks {
  display: flex;
  flex-direction: column;
  gap: 7px;
  font-size: 13px;
  padding-left: 84px;
}

.export-checks label {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
}

/* 부속 문구는 12px 한 가지로 — 11/12/13px 이 섞여 있어 크기가 들쭉날쭉해 보였다 (2026-09-18) */
.export-hint { font-size: 12px; color: #9ca3af; }

.export-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  line-height: 1.6;
  color: #6b7280;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 8px 10px;
}

.export-error {
  background: #fee2e2;
  border: 1px solid #fca5a5;
  color: #991b1b;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 12px;
}

.export-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 18px;
  border-top: 1px solid #e5e7eb;
}

.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f3f4f6;
  color: #374151;
  cursor: pointer;
  transition: background-color 150ms ease, border-color 150ms ease;
}

.export-btn:hover { background: #e5e7eb; }

.export-btn-primary {
  background: #3b82f6;
  border-color: transparent;
  color: #fff;
}

.export-btn-primary:hover { background: #2563eb; }
.export-btn:disabled { opacity: 0.55; cursor: not-allowed; }

@media (prefers-reduced-motion: reduce) {
  .export-modal { animation: none; }
  .export-modal-close,
  .export-btn,
  .export-field input[type="text"],
  .export-field select { transition: none; }
}

/* 다크 모드 */
[data-theme="dark"] .export-modal {
  background: var(--color-bg-tertiary);
  color: var(--color-text);
}

[data-theme="dark"] .export-modal-header,
[data-theme="dark"] .export-modal-footer { border-color: var(--color-border); }

[data-theme="dark"] .export-modal-close:hover { background: var(--color-hover); }

[data-theme="dark"] .export-source {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
}

[data-theme="dark"] .export-label,
[data-theme="dark"] .export-hint,
[data-theme="dark"] .export-ext { color: var(--color-text-muted); }

[data-theme="dark"] .export-field input[type="text"],
[data-theme="dark"] .export-field select {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .export-note {
  background: rgba(59, 130, 246, 0.1);
  border-color: rgba(59, 130, 246, 0.3);
  color: var(--color-text-muted);
}

[data-theme="dark"] .export-error {
  background: rgba(248, 113, 113, 0.12);
  border-color: rgba(248, 113, 113, 0.3);
  color: #fca5a5;
}

[data-theme="dark"] .export-btn {
  background: var(--color-bg-secondary);
  border-color: var(--color-border);
  color: var(--color-text);
}

[data-theme="dark"] .export-btn:hover { background: var(--color-hover); }

[data-theme="dark"] .export-btn-primary {
  background: var(--color-accent);
  border-color: transparent;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ExportDataModal.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,eAAe;EACf,QAAQ;EACR,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,wDAAwD;EACxD,yDAAyD;EACzD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,4BAA4B,+BAA+B,EAAE;;AAE7D;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;AACrC;;AAEA;6BAC6B,aAAa,EAAE,qBAAqB,EAAE;;AAEnE;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA,sEAAsE;AACtE,eAAe,eAAe,EAAE,cAAc,EAAE;;AAEhD;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gEAAgE;AAClE;;AAEA,oBAAoB,mBAAmB,EAAE;;AAEzC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,aAAa,EAAE,mBAAmB,EAAE;;AAE3D;EACE,gBAAgB,eAAe,EAAE;EACjC;;;yBAGuB,gBAAgB,EAAE;AAC3C;;AAEA,UAAU;AACV;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;2CAC2C,iCAAiC,EAAE;;AAE9E,gDAAgD,8BAA8B,EAAE;;AAEhF;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;;kCAEkC,8BAA8B,EAAE;;AAElE;;EAEE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA,wCAAwC,8BAA8B,EAAE;;AAExE;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* 데이터 내보내기 모달 — 프로젝트 컨벤션: 색 전용 transition, fade-in 160ms, reduced-motion 가드 */\r\n\r\n.export-modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: var(--color-overlay-bg, rgba(0, 0, 0, 0.5));\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1200;\r\n}\r\n\r\n.export-modal {\r\n  width: 520px;\r\n  max-width: calc(calc(100vw / var(--app-zoom, 1)) - 32px);\r\n  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 64px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  background: #fff;\r\n  color: #374151;\r\n  border-radius: 10px;\r\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.28);\r\n  animation: export-modal-in 160ms ease-out;\r\n}\r\n\r\n@keyframes export-modal-in {\r\n  from { opacity: 0; transform: translateY(-3px); }\r\n  to   { opacity: 1; transform: translateY(0); }\r\n}\r\n\r\n.export-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 14px 18px;\r\n  border-bottom: 1px solid #e5e7eb;\r\n}\r\n\r\n.export-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n}\r\n\r\n.export-modal-close {\r\n  border: none;\r\n  background: none;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  padding: 2px;\r\n  border-radius: 4px;\r\n  transition: background-color 150ms ease;\r\n}\r\n\r\n.export-modal-close:hover { background: rgba(0, 0, 0, 0.06); }\r\n\r\n.export-modal-body {\r\n  padding: 16px 18px;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.export-source {\r\n  background: #f9fafb;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  padding: 9px 12px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  font-size: 12px;\r\n}\r\n\r\n.export-source-row {\r\n  display: flex;\r\n  gap: 10px;\r\n  align-items: baseline;\r\n  min-width: 0;\r\n}\r\n\r\n.export-sql {\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  font-size: 11px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.export-field {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 13px;\r\n}\r\n\r\n.export-label {\r\n  flex-shrink: 0;\r\n  width: 74px;\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n.export-field input[type=\"text\"],\r\n.export-field select {\r\n  flex: 1;\r\n  min-width: 0;\r\n  padding: 6px 9px;\r\n  font-size: 13px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #fff;\r\n  color: inherit;\r\n  transition: border-color 150ms ease;\r\n}\r\n\r\n.export-field input[type=\"text\"]:focus,\r\n.export-field select:focus { outline: none; border-color: #3b82f6; }\r\n\r\n.export-filename {\r\n  flex: 1;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  min-width: 0;\r\n}\r\n\r\n.export-ext {\r\n  flex-shrink: 0;\r\n  font-size: 12px;\r\n  color: #9ca3af;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n}\r\n\r\n.export-checks {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 7px;\r\n  font-size: 13px;\r\n  padding-left: 84px;\r\n}\r\n\r\n.export-checks label {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* 부속 문구는 12px 한 가지로 — 11/12/13px 이 섞여 있어 크기가 들쭉날쭉해 보였다 (2026-09-18) */\r\n.export-hint { font-size: 12px; color: #9ca3af; }\r\n\r\n.export-note {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 6px;\r\n  font-size: 12px;\r\n  line-height: 1.6;\r\n  color: #6b7280;\r\n  background: #eff6ff;\r\n  border: 1px solid #bfdbfe;\r\n  border-radius: 6px;\r\n  padding: 8px 10px;\r\n}\r\n\r\n.export-error {\r\n  background: #fee2e2;\r\n  border: 1px solid #fca5a5;\r\n  color: #991b1b;\r\n  border-radius: 6px;\r\n  padding: 8px 12px;\r\n  font-size: 12px;\r\n}\r\n\r\n.export-modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 8px;\r\n  padding: 12px 18px;\r\n  border-top: 1px solid #e5e7eb;\r\n}\r\n\r\n.export-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 7px 14px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 6px;\r\n  background: #f3f4f6;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  transition: background-color 150ms ease, border-color 150ms ease;\r\n}\r\n\r\n.export-btn:hover { background: #e5e7eb; }\r\n\r\n.export-btn-primary {\r\n  background: #3b82f6;\r\n  border-color: transparent;\r\n  color: #fff;\r\n}\r\n\r\n.export-btn-primary:hover { background: #2563eb; }\r\n.export-btn:disabled { opacity: 0.55; cursor: not-allowed; }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .export-modal { animation: none; }\r\n  .export-modal-close,\r\n  .export-btn,\r\n  .export-field input[type=\"text\"],\r\n  .export-field select { transition: none; }\r\n}\r\n\r\n/* 다크 모드 */\r\n[data-theme=\"dark\"] .export-modal {\r\n  background: var(--color-bg-tertiary);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .export-modal-header,\r\n[data-theme=\"dark\"] .export-modal-footer { border-color: var(--color-border); }\r\n\r\n[data-theme=\"dark\"] .export-modal-close:hover { background: var(--color-hover); }\r\n\r\n[data-theme=\"dark\"] .export-source {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n}\r\n\r\n[data-theme=\"dark\"] .export-label,\r\n[data-theme=\"dark\"] .export-hint,\r\n[data-theme=\"dark\"] .export-ext { color: var(--color-text-muted); }\r\n\r\n[data-theme=\"dark\"] .export-field input[type=\"text\"],\r\n[data-theme=\"dark\"] .export-field select {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .export-note {\r\n  background: rgba(59, 130, 246, 0.1);\r\n  border-color: rgba(59, 130, 246, 0.3);\r\n  color: var(--color-text-muted);\r\n}\r\n\r\n[data-theme=\"dark\"] .export-error {\r\n  background: rgba(248, 113, 113, 0.12);\r\n  border-color: rgba(248, 113, 113, 0.3);\r\n  color: #fca5a5;\r\n}\r\n\r\n[data-theme=\"dark\"] .export-btn {\r\n  background: var(--color-bg-secondary);\r\n  border-color: var(--color-border);\r\n  color: var(--color-text);\r\n}\r\n\r\n[data-theme=\"dark\"] .export-btn:hover { background: var(--color-hover); }\r\n\r\n[data-theme=\"dark\"] .export-btn-primary {\r\n  background: var(--color-accent);\r\n  border-color: transparent;\r\n  color: #fff;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
